import {
	ReactElement,
	useEffect,
	useState
} from "react";
import styles from "./TimeIndicator.module.less";
import {
	DelayedIntervalHandle,
	clearDelayedInterval,
	setDelayedInterval
} from "client_legacy/ndaw/delayedInterval";
import { TimeZone } from "client/DateAndTime/timezones";
import { TimeOnly } from "client/DateAndTime/timeOnly";
import { convertToTimeOnly } from "client/DateAndTime/timeUtils";

type TimeIndicatorProps = {
	timezone: TimeZone;
};

export const TimeIndicator = (props: TimeIndicatorProps): ReactElement => {
	const {
		timezone
	} = props;

	const [top, setTop] = useState<number>(getTimeIndicatorTop(timezone));

	useEffect(
		(): () => void => {
			const now: TimeOnly = convertToTimeOnly(
				new Date(),
				timezone
			);

			const nowMilliseconds: number = now.second * 1000 + now.millisecond;
			const millisecondsUntilNextMinute = MILLISECONDS_IN_MINUTE - nowMilliseconds;

			const intervalHandle: DelayedIntervalHandle = setDelayedInterval(
				() => {
					setTop(getTimeIndicatorTop(timezone));
				},
				MILLISECONDS_IN_MINUTE,
				millisecondsUntilNextMinute
			);

			return (): void => clearDelayedInterval(intervalHandle);
		},
		[timezone]
	);

	const style = {
		top: `${top}%`
	};

	return (
		<div
			className={styles.timeIndicator}
			style={style}
		/>
	);
};

TimeIndicator.displayName = "TimeIndicator";

function getTimeIndicatorTop(timezone: TimeZone): number {
	const time: TimeOnly = convertToTimeOnly(
		new Date(),
		timezone
	);

	const currentMinutes: number = (time.hour * MINUTES_IN_HOUR) + time.minute;
	const dayColumnHeight: number = MINUTES_IN_DAY;

	return (currentMinutes * 100) / dayColumnHeight;
}

const MILLISECONDS_IN_MINUTE: number = 60000;
export const MINUTES_IN_HOUR: number = 60;
const HOURS_IN_DAY: number = 24;
const MINUTES_IN_DAY: number = HOURS_IN_DAY * MINUTES_IN_HOUR;